import { render, staticRenderFns } from "./OrderDetailsContent.vue?vue&type=template&id=0f76568a&scoped=true"
import script from "./OrderDetailsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetailsContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OrderDetailsContent.vue?vue&type=style&index=0&id=0f76568a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76568a",
  null
  
)

export default component.exports